import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  ref: "measureContainer",
  style: {"position":"absolute","left":"-99999px","top":"-99999px","white-space":"nowrap","visibility":"hidden"}
}
const _hoisted_4 = {
  ref: "measureTrack",
  class: "measure-marquee-content",
  style: {"display":"inline-flex","align-items":"center","height":"100%"}
}
const _hoisted_5 = {
  key: 0,
  class: "scrolling-image"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["fill"]
const _hoisted_10 = ["d"]
const _hoisted_11 = {
  key: 2,
  class: "scrolling-text__separator"
}
const _hoisted_12 = {
  key: 0,
  class: "scrolling-image"
}
const _hoisted_13 = ["src"]
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = ["fill"]
const _hoisted_17 = ["d"]
const _hoisted_18 = {
  key: 2,
  class: "scrolling-text__separator"
}
const _hoisted_19 = { key: 1 }
const _hoisted_20 = ["src"]
const _hoisted_21 = { key: 1 }
const _hoisted_22 = ["fill"]
const _hoisted_23 = ["d"]
const _hoisted_24 = { key: 1 }
const _hoisted_25 = ["src"]
const _hoisted_26 = {
  key: 1,
  class: "current_weather"
}
const _hoisted_27 = { class: "current__container" }
const _hoisted_28 = { class: "current" }
const _hoisted_29 = ["fill"]
const _hoisted_30 = ["d"]
const _hoisted_31 = { class: "temp-container" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("sup", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "temp_scale" }, "℉")
], -1)
const _hoisted_34 = { key: 1 }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("sup", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "temp_scale" }, "℃")
], -1)
const _hoisted_36 = {
  key: 2,
  class: "zone__content zone__content--weather-medium"
}
const _hoisted_37 = { class: "weather-medium__location" }
const _hoisted_38 = { class: "weather-medium__row" }
const _hoisted_39 = ["fill"]
const _hoisted_40 = ["d"]
const _hoisted_41 = { class: "weather-medium__temp" }
const _hoisted_42 = { key: 0 }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("sup", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "temp_scale" }, "℉")
], -1)
const _hoisted_44 = { key: 1 }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("sup", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "temp_scale" }, "℃")
], -1)
const _hoisted_46 = {
  key: 3,
  class: "zone__content",
  style: {"align-items":"center"}
}
const _hoisted_47 = { class: "temp-container" }
const _hoisted_48 = ["fill"]
const _hoisted_49 = ["d"]
const _hoisted_50 = { key: 0 }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("sup", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "temp_scale" }, "℉")
], -1)
const _hoisted_52 = { key: 1 }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("sup", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "temp_scale" }, "℃")
], -1)
const _hoisted_54 = {
  key: 4,
  class: "zone__content"
}
const _hoisted_55 = { key: 0 }
const _hoisted_56 = { key: 1 }
const _hoisted_57 = { key: 2 }
const _hoisted_58 = {
  key: 5,
  class: "zone__content"
}
const _hoisted_59 = { class: "room_code" }
const _hoisted_60 = { class: "connection_url" }
const _hoisted_61 = { key: 1 }
const _hoisted_62 = { class: "zone-heading" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Vue3Marquee = _resolveComponent("Vue3Marquee")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!

  return (_ctx.zoneContent && _ctx.zoneContent.zoneContent.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.zoneContent.allowScrolling || _ctx.zoneContent.scrollContent)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "block",
              style: _normalizeStyle(`height: ${_ctx.zoneHeight}px; width: ${_ctx.zoneWidth}px;`)
            }, [
              (_ctx.zoneContent.scrollContent)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createElementVNode("div", {
                      ref: "visibleContainer",
                      style: _normalizeStyle({ 
                    background: _ctx.zoneContent.backgroundColor,
                    color: _ctx.zoneContent.fontColor,
                    height: _ctx.zoneHeight + 'px',
                    width: _ctx.zoneWidth + 'px',
                    display: 'flex',
                    alignItems: 'center'
                    })
                    }, [
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.zoneContent.zoneContent, (content, idx) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: `m-${content.zoneType}-${idx}`,
                              class: "scrolling-text",
                              style: {"font-size":"72px","font-family":"system-ui,sans-serif","font-weight":"bold","line-height":"1","height":"100%","display":"flex","align-items":"center"}
                            }, [
                              (content.zoneType == 'image')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                                    _createElementVNode("img", {
                                      class: "scrolling-image__img",
                                      src: _ctx.getImagePreviewUrl(content, idx),
                                      style: _normalizeStyle(`height: ${_ctx.zoneHeight}px;`)
                                    }, null, 12, _hoisted_6)
                                  ]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_7, [
                                    (content.zoneType == 'weather' && _ctx.currentWeather && _ctx.currentWeather.condition && _ctx.currentWeather.condition.code && _ctx.weatherIconKey[_ctx.currentWeather.condition.code])
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                                          (_openBlock(), _createElementBlock("svg", {
                                            svg: "",
                                            fill: _ctx.weatherIconKey[_ctx.currentWeather.condition.code].fill,
                                            style: _normalizeStyle(`height: ${_ctx.zoneHeight}px;`),
                                            class: "scrolling__icon",
                                            viewBox: "0 0 24 24"
                                          }, [
                                            _createElementVNode("path", {
                                              d: _ctx.weatherIconKey[_ctx.currentWeather.condition.code].icon
                                            }, null, 8, _hoisted_10)
                                          ], 12, _hoisted_9))
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("span", null, _toDisplayString(_ctx.getTextContent(content)), 1)
                                  ])),
                              (_ctx.shouldShowSeparator(content, idx))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_11, "•"))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ], 512)
                      ], 512),
                      _createVNode(_component_Vue3Marquee, {
                        duration: _ctx.marqueeDuration,
                        pauseOnHover: false,
                        gradient: false,
                        style: {"height":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.zoneContent.zoneContent, (content, idx) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: `${content.zoneType}-${idx}`,
                              class: "scrolling-text",
                              style: {"font-size":"72px","font-family":"system-ui,sans-serif","font-weight":"normal","line-height":"1","height":"100%","display":"flex","align-items":"center"}
                            }, [
                              (content.zoneType == 'image')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                                    _createElementVNode("img", {
                                      class: "scrolling-image__img",
                                      src: _ctx.getImagePreviewUrl(content, idx),
                                      style: _normalizeStyle(`height: ${_ctx.zoneHeight}px;`)
                                    }, null, 12, _hoisted_13)
                                  ]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_14, [
                                    (content.zoneType == 'weather' && _ctx.currentWeather && _ctx.currentWeather.condition && _ctx.currentWeather.condition.code && _ctx.weatherIconKey[_ctx.currentWeather.condition.code])
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                                          (_openBlock(), _createElementBlock("svg", {
                                            svg: "",
                                            fill: _ctx.weatherIconKey[_ctx.currentWeather.condition.code].fill,
                                            style: _normalizeStyle(`height: ${_ctx.zoneHeight}px;`),
                                            class: "scrolling__icon",
                                            viewBox: "0 0 24 24"
                                          }, [
                                            _createElementVNode("path", {
                                              d: _ctx.weatherIconKey[_ctx.currentWeather.condition.code].icon
                                            }, null, 8, _hoisted_17)
                                          ], 12, _hoisted_16))
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("span", null, _toDisplayString(_ctx.getTextContent(content)), 1)
                                  ])),
                              (_ctx.shouldShowSeparator(content, idx))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_18, "•"))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["duration"])
                    ], 4)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createVNode(_component_el_carousel, {
                      "indicator-position": "none",
                      interval: "15000",
                      "pause-on-hover": "false"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.zoneContent.zoneContent, (content, idx) => {
                          return (_openBlock(), _createBlock(_component_el_carousel_item, {
                            key: `${content.zoneType}-${idx}`
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", {
                                class: "scrolling-zone not-scrolling-text",
                                style: _normalizeStyle({ 
                            background: _ctx.zoneContent.backgroundColor,
                            color: _ctx.zoneContent.fontColor,
                            height: _ctx.zoneHeight + 'px',
                            width: _ctx.zoneWidth + 'px'
                            })
                              }, [
                                (content.zoneType == 'image')
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 0,
                                      class: "zone-image",
                                      style: _normalizeStyle(`height: ${_ctx.zoneHeight}px; width: ${_ctx.zoneWidth}px;`)
                                    }, [
                                      _createElementVNode("img", {
                                        class: "zone-image__img",
                                        src: _ctx.getImagePreviewUrl(content, idx)
                                      }, null, 8, _hoisted_20)
                                    ], 4))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_21, [
                                      (content.zoneType == 'weather' && _ctx.currentWeather && _ctx.currentWeather.condition && _ctx.currentWeather.condition.code && _ctx.weatherIconKey[_ctx.currentWeather.condition.code])
                                        ? (_openBlock(), _createElementBlock("svg", {
                                            key: 0,
                                            svg: "",
                                            fill: _ctx.weatherIconKey[_ctx.currentWeather.condition.code].fill,
                                            style: _normalizeStyle(`height: ${_ctx.zoneHeight}px;`),
                                            viewBox: "0 0 24 24"
                                          }, [
                                            _createElementVNode("path", {
                                              d: _ctx.weatherIconKey[_ctx.currentWeather.condition.code].icon
                                            }, null, 8, _hoisted_23)
                                          ], 12, _hoisted_22))
                                        : _createCommentVNode("", true),
                                      _createTextVNode(" " + _toDisplayString(_ctx.getTextContent(content)), 1)
                                    ]))
                              ], 4)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]))
            ], 4))
          : (_openBlock(), _createElementBlock("div", _hoisted_24, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.zoneContent.zoneContent, (content, idx) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: `${content.zoneType}-${idx}`,
                  class: "zone__content",
                  style: _normalizeStyle({
                    background: _ctx.zoneContent.backgroundColor,
                    height: _ctx.zoneHeight + 'px',
                    width: _ctx.zoneWidth + 'px'
                    })
                }, [
                  (content.zoneType == 'image')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "zone-image",
                        style: _normalizeStyle(`height: ${_ctx.zoneHeight}px; width: ${_ctx.zoneWidth}px;`)
                      }, [
                        _createElementVNode("img", {
                          class: "zone-image__img",
                          src: _ctx.getImagePreviewUrl(content, idx)
                        }, null, 8, _hoisted_25)
                      ], 4))
                    : _createCommentVNode("", true),
                  (content.zoneType == 'weather' && _ctx.currentWeather && _ctx.weatherLayout === 'tall')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        _createElementVNode("div", {
                          style: _normalizeStyle({ color: _ctx.zoneContent.fontColor })
                        }, [
                          _createElementVNode("span", {
                            class: "current__location",
                            style: _normalizeStyle({ color: _ctx.zoneContent.fontColor })
                          }, _toDisplayString(content.content.location.name) + ", " + _toDisplayString(content.content.location.region), 5),
                          _createElementVNode("section", _hoisted_27, [
                            _createElementVNode("article", _hoisted_28, [
                              (_ctx.currentWeather && _ctx.currentWeather.condition && _ctx.currentWeather.condition.code && _ctx.weatherIconKey[_ctx.currentWeather.condition.code])
                                ? (_openBlock(), _createElementBlock("svg", {
                                    key: 0,
                                    svg: "",
                                    fill: _ctx.weatherIconKey[_ctx.currentWeather.condition.code].fill,
                                    class: "current__icon",
                                    viewBox: "0 0 24 24"
                                  }, [
                                    _createElementVNode("path", {
                                      d: _ctx.weatherIconKey[_ctx.currentWeather.condition.code].icon
                                    }, null, 8, _hoisted_30)
                                  ], 8, _hoisted_29))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_31, [
                                _createElementVNode("div", null, [
                                  (_ctx.isFahrenheit && _ctx.currentWeather.temp_f != null)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                        _createTextVNode(_toDisplayString(Math.floor(_ctx.currentWeather.temp_f)), 1),
                                        _hoisted_33
                                      ]))
                                    : (!_ctx.isFahrenheit && _ctx.currentWeather.temp_c != null)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                          _createTextVNode(_toDisplayString(Math.floor(_ctx.currentWeather.temp_c)), 1),
                                          _hoisted_35
                                        ]))
                                      : _createCommentVNode("", true)
                                ])
                              ]),
                              (_ctx.currentWeather.condition)
                                ? (_openBlock(), _createElementBlock("p", {
                                    key: 1,
                                    class: "current__summary",
                                    style: _normalizeStyle({ color: _ctx.zoneContent.fontColor })
                                  }, _toDisplayString(_ctx.currentWeather.condition.text), 5))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ], 4)
                      ]))
                    : _createCommentVNode("", true),
                  (content.zoneType == 'weather' && _ctx.currentWeather && _ctx.weatherLayout === 'medium')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                        _createElementVNode("div", {
                          style: _normalizeStyle({ color: _ctx.zoneContent.fontColor }),
                          class: "zone__content zone__content--weather-medium"
                        }, [
                          _createElementVNode("div", _hoisted_37, _toDisplayString(content.content.location.name) + ", " + _toDisplayString(content.content.location.region), 1),
                          _createElementVNode("div", _hoisted_38, [
                            (_ctx.currentWeather && _ctx.currentWeather.condition && _ctx.currentWeather.condition.code && _ctx.weatherIconKey[_ctx.currentWeather.condition.code])
                              ? (_openBlock(), _createElementBlock("svg", {
                                  key: 0,
                                  svg: "",
                                  fill: _ctx.weatherIconKey[_ctx.currentWeather.condition.code].fill,
                                  class: "current__icon-small",
                                  viewBox: "0 0 24 24"
                                }, [
                                  _createElementVNode("path", {
                                    d: _ctx.weatherIconKey[_ctx.currentWeather.condition.code].icon
                                  }, null, 8, _hoisted_40)
                                ], 8, _hoisted_39))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_41, [
                              (_ctx.isFahrenheit && _ctx.currentWeather.temp_f != null)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                    _createTextVNode(_toDisplayString(Math.floor(_ctx.currentWeather.temp_f)), 1),
                                    _hoisted_43
                                  ]))
                                : (!_ctx.isFahrenheit && _ctx.currentWeather.temp_c != null)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                      _createTextVNode(_toDisplayString(Math.floor(_ctx.currentWeather.temp_c)), 1),
                                      _hoisted_45
                                    ]))
                                  : _createCommentVNode("", true)
                            ])
                          ])
                        ], 4)
                      ]))
                    : _createCommentVNode("", true),
                  (content.zoneType == 'weather' && _ctx.currentWeather && _ctx.weatherLayout === 'small')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                        _createElementVNode("div", {
                          style: _normalizeStyle({ color: _ctx.zoneContent.fontColor }),
                          class: "zone__content"
                        }, [
                          _createElementVNode("div", _hoisted_47, [
                            (_ctx.currentWeather && _ctx.currentWeather.condition && _ctx.currentWeather.condition.code && _ctx.weatherIconKey[_ctx.currentWeather.condition.code])
                              ? (_openBlock(), _createElementBlock("svg", {
                                  key: 0,
                                  svg: "",
                                  fill: _ctx.weatherIconKey[_ctx.currentWeather.condition.code].fill,
                                  class: "current__icon-small",
                                  viewBox: "0 0 24 24"
                                }, [
                                  _createElementVNode("path", {
                                    d: _ctx.weatherIconKey[_ctx.currentWeather.condition.code].icon
                                  }, null, 8, _hoisted_49)
                                ], 8, _hoisted_48))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", null, [
                              (_ctx.isFahrenheit && _ctx.currentWeather.temp_f != null)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                    _createTextVNode(_toDisplayString(Math.floor(_ctx.currentWeather.temp_f)), 1),
                                    _hoisted_51
                                  ]))
                                : (!_ctx.isFahrenheit && _ctx.currentWeather.temp_c != null)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                      _createTextVNode(_toDisplayString(Math.floor(_ctx.currentWeather.temp_c)), 1),
                                      _hoisted_53
                                    ]))
                                  : _createCommentVNode("", true)
                            ])
                          ])
                        ], 4)
                      ]))
                    : _createCommentVNode("", true),
                  (content.zoneType == 'dateTime')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                        _createElementVNode("div", {
                          style: _normalizeStyle({ color: _ctx.zoneContent.fontColor }),
                          class: "time-container"
                        }, [
                          (content.content.showDay)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_55, _toDisplayString(_ctx.dayText), 1))
                            : _createCommentVNode("", true),
                          (content.content.showDate)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_56, _toDisplayString(_ctx.dateText), 1))
                            : _createCommentVNode("", true),
                          (content.content.showTime)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_57, _toDisplayString(_ctx.timeText), 1))
                            : _createCommentVNode("", true)
                        ], 4)
                      ]))
                    : _createCommentVNode("", true),
                  (content.zoneType == 'connectionInfo')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                        _createElementVNode("div", {
                          class: "connection_container",
                          style: _normalizeStyle({ color: _ctx.zoneContent.fontColor })
                        }, [
                          _createElementVNode("div", null, [
                            _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.roomCode), 1)
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("span", _hoisted_60, _toDisplayString(_ctx.connectionUrl), 1)
                          ])
                        ], 4)
                      ]))
                    : _createCommentVNode("", true)
                ], 4))
              }), 128))
            ]))
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_61, [
        _createElementVNode("h1", _hoisted_62, "Zone " + _toDisplayString(_ctx.zoneNumber), 1)
      ]))
}